module.exports = __webpack_public_path__ + "img/kep11.8bf20f0e.jpg";